import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginForm } from '@/components/auth/LoginForm';
import { UnauthenticatedOnly } from '@/components/auth/AuthGuard';

export const Route = createFileRoute('/_auth/login')({
    component: LoginPage,
    beforeLoad: async ({ context, search }) => {
        console.log("🚀 ~ context:", context.auth)
        // If user is already authenticated, redirect to dashboard or the original destination
        const session = context.auth?.data
        const isPending = context.auth?.isPending
        console.log("🚀 ~ session:", session)
        if (!isPending && session?.user) {
            const redirectTo = (search as any)?.redirect || '/dashboard';
            console.log('Login beforeLoad - User already authenticated, redirecting to:', redirectTo);
            throw redirect({
                to: redirectTo,
            });
        }
    },
});

function LoginPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <div className="w-full max-w-md">
                {/* <UnauthenticatedOnly
                    fallback={
                        <div className="text-center">
                            <p className="text-muted-foreground">You are already signed in.</p>
                        </div>
                    }
                >
                
                </UnauthenticatedOnly> */}

<LoginForm />
            </div>
        </div>
    );
} 